import IApiError from "@/models/IApiError";

export class ModelStateError extends Error {
  static TypeName: string = "ModelStateError";
  type: string = ModelStateError.TypeName;
  apiErrors: IApiError[];
  constructor(message: string, apiErrors: IApiError[]){
    super(message);
    this.apiErrors = apiErrors;
  }
}

export abstract class BaseService {
  protected readonly api = process.env.VUE_APP_API_HOST + "/api"; 
}
